import { LicenseCode } from './LicenseCode';

export const LICENSES_WITH_ICONS = [
  LicenseCode.Email,
  LicenseCode.Sms,
  LicenseCode.Ma,
  LicenseCode.Website,
  LicenseCode.OneAPI,
  LicenseCode.FormsAndPages,
  LicenseCode.EcomFlows,
  LicenseCode.EcomRecom,
  LicenseCode.Event,
  LicenseCode.Integrations,
];
